import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { useRouter } from 'next/router'
import { Geist, Geist_Mono, La_Belle_Aurore, Newsreader } from 'next/font/google'
import { SiteHeader } from '@/components/generals/site-header'
import { PaperFilters } from '@/components/generals/paper-filters'
import { SmoothScroll } from '@/components/generals/smooth-scroll'
import { PageTransition } from '@/components/generals/page-transition'
import { RevealController } from '@/components/generals/reveal-controller'

const sans = Geist({
    subsets: ['latin']
})

const mono = Geist_Mono({
    subsets: ['latin'],
    preload: false
})

const serif = Newsreader({
    subsets: ['latin'],
    style: ['normal', 'italic'],
    axes: ['opsz']
})

const hand = La_Belle_Aurore({
    subsets: ['latin'],
    weight: '400'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${serif.style.fontFamily};--font-app-serif:${serif.style.fontFamily};--font-app-hand:${hand.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    const router = useRouter()
    const pageKey = router.asPath.split(/[?#]/)[0]

    return (
        <div className='font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <PaperFilters />
            <SmoothScroll />
            <RevealController />
            <SiteHeader />

            <PageTransition>
                <Component key={pageKey} {...pageProps} />
            </PageTransition>
        </div>
    )
}

export default App
